module.exports = __webpack_public_path__ + "static/media/WKMCS.698ab862.jpg";